/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RestrictionSetSessionLockdownParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('set')],
    ['maxEntries', codecNumber, 'max_entries'],
    ['heartbeatEnforced', codecBoolean, 'heartbeat_enforced'],
]);
export class RestrictionSetSessionLockdown extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RestrictionSetSessionLockdownParser.decode(input).map(res => new RestrictionSetSessionLockdown(res));
    }
    static unsafeDecode(input) {
        return RestrictionSetSessionLockdown.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RestrictionSetSessionLockdownParser.encode(data);
    }
    static schema() {
        return RestrictionSetSessionLockdownParser.schema();
    }
}
